import React from 'react';
import { useSelector } from 'react-redux';

import Drawer, {
  DrawerItem,
  DrawerItemContent,
  DrawerItemTitle
} from 'dpl/common/components/Drawer';
import { isLessThanBreakpoint } from 'dpl/util/grid';

import { NAV_SECTION_IDS } from '../utils/constants';

const IS_LT_LARGE = isLessThanBreakpoint('lg');

export default function FaqsSection() {
  const { overviewPageData } = useSelector(({ server }) => server);

  return (
    <div
      className="FaqsSection row ph5 pt10 pt0-lg ph20-md"
      id={NAV_SECTION_IDS.FAQS}
    >
      <div className="col-12">
        <h2 className="mb12-md f6 f8-md lh-title">FAQs</h2>
        {overviewPageData.faqs.map((faq, idx) => (
          <Drawer key={idx} initialOpenKey={faq.question}>
            <DrawerItem className="bb b--black" itemKey={faq.question}>
              <DrawerItemTitle
                iconClassName="black"
                iconOpenName="minus"
                iconCloseName="plus"
                iconSize={IS_LT_LARGE ? '24px' : '48px'}
              >
                <h2 className="pv2 flex items-center f4 f6-md lh-normal">
                  {faq.question}
                </h2>
              </DrawerItemTitle>
              <DrawerItemContent>
                <p className="mb3 font-16-mobile">{faq.answer}</p>
              </DrawerItemContent>
            </DrawerItem>
          </Drawer>
        ))}
      </div>
    </div>
  );
}
